import { render, staticRenderFns } from "./pwa_article_about.vue?vue&type=template&id=64c3a70a&scoped=true&"
import script from "./pwa_article_about.vue?vue&type=script&lang=js&"
export * from "./pwa_article_about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3a70a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c3a70a')) {
      api.createRecord('64c3a70a', component.options)
    } else {
      api.reload('64c3a70a', component.options)
    }
    module.hot.accept("./pwa_article_about.vue?vue&type=template&id=64c3a70a&scoped=true&", function () {
      api.rerender('64c3a70a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/texts/pwa_article_about.vue"
export default component.exports